module.exports = __webpack_public_path__ + "static/media/study-material-banner.e1d1be84.png";